import { TEventsKeys } from '@core/types';

export const enum EEVents {
  ON_FIELD_VALIDATION_TOGGLE = 'ON_FIELD_VALIDATION_TOGGLE',
  ON_FIELD_MOUNT = 'ON_FIELD_MOUNT',
  ON_FIELD_CHANGE = 'ON_FIELD_CHANGE',
  ON_FIELD_BLUR = 'ON_FIELD_BLUR',
  ON_FIELD_FOCUS = 'ON_FIELD_FOCUS',
  ON_FIELD_REHYDRATE = 'ON_FIELD_REHYDRATE',
  ON_FIELD_CLEARED = 'ON_FIELD_CLEARED',
  ON_FIELD_CLICK = 'ON_FIELD_CLICK',
  ON_FIELD_KEYUP = 'ON_FIELD_KEYUP',
  ON_FIELD_KEYDOWN = 'ON_FIELD_KEYDOWN',
  ON_FIELD_BINDED = 'ON_FIELD_BINDED',

  AFTER_FIELD_API_CALL = 'AFTER_FIELD_API_CALL',

  RUN_FIELD_VALIDATIONS = 'RUN_FIELD_VALIDATIONS',
  RUN_FIELD_MASKS = 'RUN_FIELD_MASKS',
  RUN_FIELD_FORMATTERS = 'RUN_FIELD_FORMATTERS',

  ON_SCOPE_CHANGE = 'ON_SCOPE_CHANGE',

  ON_FORM_REHYDRATE = 'ON_FORM_REHYDRATE',
  ON_FORM_SUBMIT = 'ON_FORM_SUBMIT',
  ON_FORM_MOUNT = 'ON_FORM_MOUNT',
  ON_FORM_UN_MOUNT = 'ON_FORM_UN_MOUNT',
  ON_FORM_DATA = 'ON_FORM_DATA',
  ON_FORM_DESTROY_FIELD = 'ON_FORM_DESTROY_FIELD',

  NAVIGATE_STEP = 'NAVIGATE_STEP',
  NAVIGATE_STEP_FORWARD = 'NAVIGATE_STEP_FORWARD',
  NAVIGATE_STEP_BACK = 'NAVIGATE_STEP_BACK',

  VALIDATE_FORM = 'VALIDATE_FORM',

  BIND_FIELDS = 'BIND_FIELDS',

  LOG = 'LOG',
}

export const CoreEvents: Record<TEventsKeys, TEventsKeys> = {
  ON_FIELD_VALIDATION_TOGGLE: 'ON_FIELD_VALIDATION_TOGGLE',
  ON_FIELD_MOUNT: 'ON_FIELD_MOUNT',
  ON_FIELD_CHANGE: 'ON_FIELD_CHANGE',
  ON_FIELD_BLUR: 'ON_FIELD_BLUR',
  ON_FIELD_FOCUS: 'ON_FIELD_FOCUS',
  ON_FIELD_REHYDRATE: 'ON_FIELD_REHYDRATE',
  ON_FIELD_CLEARED: 'ON_FIELD_CLEARED',
  ON_FIELD_CLICK: 'ON_FIELD_CLICK',
  ON_FIELD_KEYUP: 'ON_FIELD_KEYUP',
  ON_FIELD_KEYDOWN: 'ON_FIELD_KEYDOWN',
  ON_FIELD_BINDED: 'ON_FIELD_BINDED',

  AFTER_FIELD_API_CALL: 'AFTER_FIELD_API_CALL',

  RUN_FIELD_VALIDATIONS: 'RUN_FIELD_VALIDATIONS',
  RUN_FIELD_FORMATTERS: 'RUN_FIELD_FORMATTERS',

  RUN_FIELD_MASKS: 'RUN_FIELD_MASKS',
  ON_SCOPE_CHANGE: 'ON_SCOPE_CHANGE',

  ON_FORM_REHYDRATE: 'ON_FORM_REHYDRATE',
  ON_FORM_SUBMIT: 'ON_FORM_SUBMIT',
  ON_FORM_MOUNT: 'ON_FORM_MOUNT',
  ON_FORM_UN_MOUNT: 'ON_FORM_UN_MOUNT',
  ON_FORM_DATA: 'ON_FORM_DATA',
  ON_FORM_DESTROY_FIELD: 'ON_FORM_DESTROY_FIELD',

  NAVIGATE_STEP: 'NAVIGATE_STEP',
  NAVIGATE_STEP_FORWARD: 'NAVIGATE_STEP_FORWARD',
  NAVIGATE_STEP_BACK: 'NAVIGATE_STEP_BACK',

  VALIDATE_FORM: 'VALIDATE_FORM',

  BIND_FIELDS: 'BIND_FIELDS',

  LOG: 'LOG',
};
